<template>
  <div class="about">
    <h1>Events for a better world!</h1>
  </div>
</template>
